import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'lib-toggle',
    templateUrl: './toggle.component.html',
    styleUrls: ['./toggle.component.scss'],
    standalone: false
})
export class ToggleComponent {
  @Input() label: string | null = null;
  @Input() isChecked?: boolean = false;
  @Input() noBorder: boolean = false;
  @Input() formId!: string;
  @Input() fullWidth: boolean = false;
  @Input() disabled?: boolean = false;
  @Output() toggleEvent = new EventEmitter<boolean>();

  onToggle() {
    if (!this.disabled) {
      this.toggleEvent.emit(this.isChecked)
    }
  }
}
